export enum MeritNewHireState {
  None = 'None',
  ForReview = 'ForReview',
  Rejected = 'Rejected',
  Approved = 'Approved'
}
